// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html{height:100%}body,html{background-color:var(--background-page-color)}body{position:relative;display:flex;flex-direction:column;margin:0;padding:0;width:100%;min-height:100vh;min-width:320px;font-family:var(--font-family);font-size:14px;-webkit-tap-highlight-color:transparent}::-moz-focus-inner,::-moz-focus-outer{border:0;padding:0}.container{position:relative;width:100%;max-width:1000px;margin:0 auto;padding:0 32px;box-sizing:border-box}.grecaptcha-badge{display:none}", ""]);
// Exports
module.exports = exports;
